var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 8,
    viewBox: "0 0 21 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16553 0.5C4.16553 0.223858 4.38938 1.09423e-08 4.66553 0C4.94167 -1.09423e-08 5.16553 0.223858 5.16553 0.5L4.16553 0.5ZM5.01908 7.85355C4.82382 8.04882 4.50724 8.04882 4.31197 7.85355L1.12999 4.67157C0.934731 4.47631 0.934731 4.15973 1.12999 3.96447C1.32526 3.7692 1.64184 3.7692 1.8371 3.96447L4.66553 6.79289L7.49395 3.96447C7.68922 3.7692 8.0058 3.7692 8.20106 3.96447C8.39632 4.15973 8.39632 4.47631 8.20106 4.67157L5.01908 7.85355ZM5.16553 0.5L5.16553 7.5L4.16553 7.5L4.16553 0.5L5.16553 0.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6655 1.00012L10.6655 1.00012",
    stroke: "#111827",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6655 4L10.6655 4",
    stroke: "#111827",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6655 7L10.6655 7",
    stroke: "#111827",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesc);
export default __webpack_public_path__ + "static/media/desc.950970627694d44e4909052f727d6c2e.svg";
export { ForwardRef as ReactComponent };